import { useLocation } from 'react-router-dom'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import SelfAssessmentCard from 'components/organisms/assessments/SelfAssessmentCard'
import { Box } from '@mui/material'

const AssessmentSelf = () => {
  const location = useLocation()
  const goalId = location.state?.goalId
  const firstTime = location.state?.firstTime
  const isCurrentGoal = location.state?.currentGoal
  const cohortUser = location.state?.cohortUser

  return (
    <HomePage>
      <Box height={12} /> {/* This is a spacer */}
      <SelfAssessmentCard
        goalId={goalId}
        showLandingPopup={firstTime || isCurrentGoal}
        cohortUser={cohortUser}
      />
    </HomePage>
  )
}

export default AssessmentSelf
